import React, { useEffect, useState } from "react";
import useRouter from "hooks/useRouter";
import useSearch from "redux/hooks/useSearch";
import { Image } from "@leafly-com/frontend-components";
import { Action, Category, trackEvent } from "utils/trackEvent";

const BrandResults: React.FC = () => {
  const placeholder =
    "https://public.leafly.com/consumer-web/brands/brand-placeholder.svg";
  const ITEMS_PER_LOAD = 8;

  const {
    parsedQuery: { q, searchCategory },
  } = useRouter();
  const { brand: brands, loadMoreSearchResults } = useSearch();

  const viewingCountOnLoad = searchCategory === "brand" ? 12 : 4;
  const [viewingCount, setViewingCount] = useState(viewingCountOnLoad);

  useEffect(() => {
    setViewingCount(viewingCountOnLoad);
  }, [searchCategory]);

  const handleLoadMore = async () => {
    document.activeElement instanceof HTMLElement &&
      document.activeElement.blur();
    const newViewingCount = ITEMS_PER_LOAD + viewingCount;
    loadMoreSearchResults("brand", newViewingCount);
    trackEvent(
      Category.searchResults,
      Action.searchResultClicked,
      "load more brand results button"
    );
    setViewingCount(newViewingCount);
  };

  if (!brands || !brands.length) return null;

  return (
    <>
      <h3 className="heading--l">Brands</h3>
      <div className="font-normal mb-lg">matching "{q}"</div>
      <div className="row">
        {brands.slice(0, viewingCount).map((brand) => {
          return (
            <div className="col-1/2 md:col-1/3 lg:col-1/4 mb-md" key={brand.id}>
              <a
                href={`/search/shop?shopCategory=brand&shopName=${encodeURIComponent(
                  brand.name
                )}`}
                onClick={() =>
                  trackEvent(
                    Category.searchResults,
                    Action.searchResultClicked,
                    `brand quick access - ${brand.name}`
                  )
                }
                className="text-center block p-sm md:p-xs"
              >
                <Image
                  src={brand.logo || placeholder}
                  alt={brand.name}
                  sizes={[156]}
                  ratio="square"
                  className="mb-sm object-contain rounded-full elevation-low"
                />
                <span className="text-green">{brand.name}</span>
              </a>
            </div>
          );
        })}
      </div>
      {brands.length >= viewingCount && (
        <button
          className="button mt-lg lg:mt-xl"
          onClick={handleLoadMore}
          data-testid="brand-results-load-more"
        >
          load more brand results
        </button>
      )}
    </>
  );
};

export default BrandResults;
